import React from "react";
import PropTypes from "prop-types";
import Title from "../../../../components/Title";
import { Grid } from "../../../../components/Grid";
import Icon from "../../../../components/Icon";
import ClassificationIcon from "../../../../components/ClassificationIcon";
import SampleDetailsLink from "../../../../components/SampleDetailsLink";
import { route } from "../../../../shim/jsbridge";

const SourcesRelationships = ({
  relationships,
  showCloudDetailsLink = true
}) => {
  const {
    container_samples: topLevelContainers = [],
    parent_samples: directParents = []
  } = relationships;

  const gridSchema = {
    fields: [
      {
        name: "_available",
        displayTitle: "",
        className: "samples-grid__icon-cell",
        component: data => {
          if (data.location === "local") {
            return <Icon name="format" />;
          }

          return <Icon name={"cloud"} />;
        },
        style: {
          width: "2%",
          textAlign: "center"
        }
      },
      {
        name: "status",
        displayTitle: <ClassificationIcon />,
        component: data => {
          const { classification, factor } = data;

          return (
            <ClassificationIcon
              classification={classification}
              riskScore={factor}
            />
          );
        },
        style: {
          width: "2%",
          textAlign: "center",
          paddingRight: "15px",
          paddingLeft: "5px"
        }
      },
      {
        name: "sha1",
        displayTitle: "Name",
        className: "overflow-ellipsis",
        component: data => {
          const { sha1, classification, location } = data;
          const sampleRecord = {
            sha1,
            threat_status: classification,
            filename: sha1
          };

          if (location === "local") {
            return <SampleDetailsLink sampleRecord={sampleRecord} />;
          }

          return (
            <SampleDetailsLink
              sampleRecord={sampleRecord}
              href={
                !showCloudDetailsLink
                  ? `${route("search")}?q=hashes:${sha1}&location=cloud`
                  : null
              }
            />
          );
        },
        style: {
          width: "40%"
        }
      },
      {
        name: "sample_type",
        displayTitle: "Format",
        className: "overflow-ellipsis",
        style: {
          width: "10%"
        },
        component: data => data.format
      }
    ]
  };

  return (
    <>
      {topLevelContainers.length || directParents.length ? (
        <>
          {!!topLevelContainers.length && (
            <div style={{ marginBottom: "25px" }}>
              <Title text="Top-level Containers" Level="h2" />
              <Grid schema={gridSchema} data={topLevelContainers} />
            </div>
          )}
          {!!directParents.length && (
            <div>
              <Title text="Direct Parents" Level="h2" />
              <Grid schema={gridSchema} data={directParents} />
            </div>
          )}
        </>
      ) : (
        <p>
          <b>No Parents for This Sample</b>
        </p>
      )}
    </>
  );
};

SourcesRelationships.propTypes = {
  relationships: PropTypes.shape(),
  showCloudDetailsLink: PropTypes.bool
};

export default SourcesRelationships;
